import { SkillNameError } from 'pages/Settings/pages/Organization/SkillsPage/SkillsPage.types';

const normalizeSkillName = (name: string) => name.trim().toLowerCase();

export const getSkillNameError = (name: string, otherNames: string[]): SkillNameError | null => {
  if (!name.trim()) return 'SKILL_NAME_REQUIRED';
  const normalizedName = normalizeSkillName(name);
  if (otherNames.some((otherName) => normalizeSkillName(otherName) === normalizedName)) {
    return 'SKILL_NAME_DUPLICATE';
  }
  return null;
};
